module.exports = "/img/_/_/_/assets/images/creeper/book/common//22.jpg?293d4e1dbdd09197874d5bc61b423673";